<template>
  <div class="flex flex-col">
    <div class="relative max-w-lg">
      <h2 class="text-lg font-bold mb-4">Ajouter un payment</h2>
      <h2 class="mb-1">Facture: FA-{{ doc_number }}</h2>
      <p class="mb-4">Montant restant: &euro;&nbsp;{{ parseFloat(amount_open).toFixed(2) }}</p>

      <label for="date" class="block text-sm font-medium text-gray-700"> Date </label>
      <div class="relative mb-4">
        <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <i class="fas fa-calendar text-gray-400"></i>
        </div>
        <input
          v-model="formValues.date"
          :disabled="disableButtons"
          datepicker
          type="date"
          name="date"
          id="date"
          class="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-indigo-500 dark:focus:border-indigo-500"
          placeholder="Select date ..."
        />
      </div>

      <label for="amount" class="block text-sm font-medium text-gray-700"> Montant payée </label>
      <input
        v-model="formValues.amount"
        :disabled="disableButtons"
        type="number"
        name="amount"
        id="amount"
        step="0.01"
        min="0.01"
        max="9999999999"
        class="mb-4 bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-indigo-500 focus:border-indigo-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-indigo-500 dark:focus:border-indigo-500"
        placeholder="Montant ..."
      />

      <label for="method" class="block text-sm font-medium text-gray-700"> Moyen de payment </label>
      <select
        v-model="formValues.method"
        name="method"
        id="method"
        :disabled="disableButtons"
        class="mb-4 p-2 block w-full sm:text-sm shadow-sm focus:ring-indigo-500 focus:border-indigo-500 border rounded-md"
        :class="{ 'border-gray-200': !disableButtons, 'bg-gray-200 border-gray-200': disableButtons }"
      >
        <option
          v-for="(label, value) in PAYMENT_METHODS"
          :key="value"
          :value="value"
          :selected="value === formValues.method"
        >
          {{ label }}
        </option>
      </select>

      <button
        :disabled="disableButtons"
        @click.stop.prevent="submit"
        type="submit"
        class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
      >
        <i v-if="disableButtons" class="fas fa-spinner mt-1"></i>
        <span v-else>Sauvegarder</span>
      </button>
    </div>
  </div>
</template>

<script>
import { ref, watch } from 'vue'
import { useStore } from 'vuex'
import useApi from '@/hooks/useApi'
import PAYMENT_METHODS from '@/constants/PAYMENT_METHODS'

export default {
  props: {
    doc_number: [String, Number],
    amount_open: [String, Number],
  },
  theme() {
    return {
      title: 'Ajouter un payment',
    }
  },
  emits: ['payment'],
  setup(props, { emit }) {
    const d = new Date()
    const disableButtons = ref(false)
    const formValues = ref({
      doc_number: props.doc_number,
      date: [d.getDate(), d.getMonth() + 1, d.getFullYear()].map(n => (n > 9 ? n : `0${n}`)).join('/'),
      amount: props.amount_open > 0 ? parseFloat(props.amount_open).toFixed(2) : null,
      method: Object.keys(PAYMENT_METHODS)[0],
    })

    const countDecimals = value => {
      if (Math.floor(value) === Number(value)) return 0
      const str = String(Number(value))
      const parts = str.split('.')
      if (parts.length > 1) return parts[1].length
      return 0
    }

    if (props.amount_open > 0) {
      watch(
        () => formValues.value.amount,
        val => {
          if (Number(val) > Number(props.amount_open)) {
            formValues.value.amount = props.amount_open
            return
          }
          if (countDecimals(val) > 2) {
            formValues.value.amount = parseFloat(Math.floor(formValues.value.amount * 100) / 100).toFixed(2)
          }
        },
      )
    }

    const api = useApi()
    const store = useStore()

    const submit = () => {
      disableButtons.value = true
      api.invoices
        .addPayment(formValues.value)
        .then(() => {
          emit('payment', formValues.value)
          store.commit('GET_COUNTERS')
        })
        .finally(() => {
          setTimeout(() => {
            if (disableButtons?.value) disableButtons.value = false
          }, 500)
        })
    }

    return { disableButtons, formValues, submit, PAYMENT_METHODS }
  },
}
</script>

<style></style>
